const state = () => ({
  userId: 0,
  currentUserWishlist: {},
  currentUserWishlistItems: [],
  userWishlists: [],
  lastVisitedGuestWishlists: [],
  currentVariationId: 0,
  currentWishlistItemId: 0,
  isLoading: false,
  createWishlistLoading: false,
  userWishlistsInitiallyLoaded: false
})

const mutations =
    {
      setCurrentWishlist (state, wishlist) {
        state.currentUserWishlist = wishlist
      },
      setCurrentWishlistItems (state, items) {
        const cleanedWishlistItems = items.filter(itm => itm.variationId > 0) // fix only add items with actual variationId
        state.currentUserWishlistItems = cleanedWishlistItems
      },
      setCurrentWishlistItemId (state, itemId) {
        state.currentWishlistItemId = itemId
      },
      setUserWishlistsInitiallyLoaded (state) {
        state.userWishlistsInitiallyLoaded = true
      },
      setLastVisitedGuestWishlists (state, wishlists) {
        state.lastVisitedGuestWishlists = wishlists.data
      },
      updateCurrentWishlistItem (state, item) {
        const wishlistItem = state.currentUserWishlistItems.find(entry => entry.variationId === item.variationId)
        wishlistItem.neededQuantity = parseInt(item.neededQuantity)
        wishlistItem.boughtQuantity = parseInt(item.boughtQuantity)
        wishlistItem.comment = item.comment
        wishlistItem.isActive = item.isActive
      },
      setUserWishlists (state, { wishlistArray, restRequested }) {
        if (!state.userWishlistsInitiallyLoaded || restRequested) {
          state.userWishlists = wishlistArray
          state.userWishlistsInitiallyLoaded = true
        }
      },
      setIsLoading (state, isLoading) {
        state.isLoading = isLoading
      },
      setCreateWishlistLoading (state, isLoading) {
        state.createWishlistLoading = isLoading
      },
      addItemToUserWishlist (state, { varId, wishlistId }) {
        state.userWishlists.filter(wl => wl.id === wishlistId)[0].wishlistItems.push(varId)
      },
      removeItemFromUserWishlist (state, { varId, wishlistId }) {
        // all user lists
        const wishlist = state.userWishlists.filter(wl => wl.id === wishlistId)[0]
        if (wishlist) {
          wishlist.wishlistItems = wishlist.wishlistItems.filter(a => a !== varId)
          state.userWishlists.filter(wl => wl.id === wishlistId)[0] = wishlist
        }

        // current user lists
        if (state.currentUserWishlistItems.length > 0) {
          state.currentUserWishlistItems = state.currentUserWishlistItems.filter(a => a.variationId !== varId)
        }
      },
      addUserWishlist (state, wishlistData) {
        const newWishlist = {
          id: wishlistData.id,
          accessCode: wishlistData.accessCode,
          name: wishlistData.name,
          colorScheme: wishlistData.colorScheme,
          wishlistItems: []
        }
        state.userWishlists.push(newWishlist)
      },
      deleteUserWishlist (state, deletedWishlistId) {
        if (deletedWishlistId) { state.userWishlists = state.userWishlists.filter(wl => wl.id !== deletedWishlistId) }
      },
      setCurrentVariationId (state, varId) {
        state.currentVariationId = varId
      },
      setIsOverview (state, isOverview) {
        state.isOverview = !!isOverview
      }
    }

const actions =
    {
      updateOverview ({ commit }, { val }) {
        commit('setIsOverview', val)
      },
      initUserWishlists ({ commit, state }) {
        // dont init if already done
        if (state.userWishlistsInitiallyLoaded) return
        commit('setUserWishlistsInitiallyLoaded')
        commit('setIsLoading', true)
        return $.ajax({
          type: 'GET',
          url: '/rest/wishlist/',
          success: function (data) {
            commit('setUserWishlists', { wishlistArray: data, restRequested: true })
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      initLastVisitedGuestWishlists ({ commit, state }) {
        commit('setIsLoading', true)
        return $.ajax({
          type: 'GET',
          url: '/rest/wishlist/last/',
          success: function (data) {
            commit('setLastVisitedGuestWishlists', { data })
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      addLastVisitedGuestlist ({ commit }, { accessCode }) {
        if (typeof accessCode !== 'string') {
          return
        }

        commit('setIsLoading', true)
        return $.ajax({
          type: 'POST',
          url: '/rest/wishlist/last/',
          data: { guestAccessCode: accessCode },
          success: function (data) {
            commit('setLastVisitedGuestWishlists', { data })
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      addToBKWishList ({ commit }, { varId, wishlistId }) {
        commit('setIsLoading', true)
        commit('addItemToUserWishlist', { varId, wishlistId })
        return $.ajax({
          type: 'POST',
          url: '/rest/wishlist/' + wishlistId + '/',
          data: { variationId: varId },
          success: function (data) { },
          error: function (jqXHR, textStatus, errorThrown) {
            commit('removeItemFromUserWishlist', { varId, wishlistId })
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      removeFromBKWishList ({ commit }, { varId, wishlistId }) {
        commit('setIsLoading', true)
        commit('removeItemFromUserWishlist', { varId, wishlistId })
        return $.ajax({
          type: 'DELETE',
          url: '/rest/wishlist/' + wishlistId + '/variation/' + varId + '/',
          success: function (data) {},
          error: function (jqXHR, textStatus, errorThrown) {
            commit('addItemToUserWishlist', { varId, wishlistId })
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      createWishlist ({ commit }, { name }) {
        commit('setCreateWishlistLoading', true)
        return $.ajax({
          type: 'POST',
          url: '/rest/wishlist/',
          data: { name: name },
          success: function (data) {
            commit('addUserWishlist', data)
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setCreateWishlistLoading', false)
          }
        })
      },
      deleteWishlist ({ commit }, { id }) {
        commit('setCreateWishlistLoading', true)
        commit('deleteUserWishlist', id)
        return $.ajax({
          type: 'DELETE',
          url: '/rest/wishlist/' + id + '/',
          success: function () { },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setCreateWishlistLoading', false)
          }
        })
      },
      setAddToWishlistData ({ commit }, { variationId }) {
        commit('setCurrentVariationId', variationId)
      },
      updateWishlistItem ({ commit, state }, { submittedData }) {
        commit('setIsLoading', true)
        return $.ajax({
          type: 'PUT',
          url: '/rest/wishlist/' + state.currentUserWishlist.id + '/variation/' + submittedData.variationId + '/',
          data: submittedData,
          success: function (resp) {
            commit('updateCurrentWishlistItem', resp)
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      incrementBoughtQuantity ({ commit, state }, { submittedData }) {
        commit('setIsLoading', true)
        return $.ajax({
          type: 'PUT',
          url: '/rest/wishlist/' + state.currentUserWishlist.id + '/variation/' + submittedData.variationId + '/bought/',
          data: submittedData,
          success: function (resp) {
            commit('updateCurrentWishlistItem', resp)
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      updateWishlist ({ commit, state }, { submittedData }) {
        commit('setIsLoading', true)
        return $.ajax({
          type: 'PUT',
          url: '/rest/wishlist/' + submittedData.id + '/',
          data: submittedData,
          success: function (resp) {
            commit('setCurrentWishlist', resp)
          },
          error: function (jqXHR, textStatus, errorThrown) {
            console.error(errorThrown)
          },
          complete: function () {
            commit('setIsLoading', false)
          }
        })
      },
      setCurrentWishlistData ({ commit }, { data }) {
        commit('setCurrentWishlist', data.wishlist)
        commit('setCurrentWishlistItems', data.wishlistItems)
      },
      setUserWishlistsData ({ commit }, { data }) {
        commit('setUserWishlists', { wishlistArray: data, restRequested: false })
      },
      setCurrentWishlistItemId ({ commit }, { payload }) {
        commit('setCurrentWishlistItemId', payload)
      }

    }

const getters =
    {
      currentWishlist (state) {
        return state.currentUserWishlist
      },
      currentWishlistItems (state) {
        return state.currentUserWishlistItems
      },
      loading (state) {
        return state.isLoading
      },
      createWishlistIsLoading (state) {
        return state.createWishlistLoading
      },
      currentWishlistItemId (state) {
        return state.currentWishlistItemId
      },
      wishlistNumber (state) {
        return state.userWishlists.length
      }
    }

export default {
  state,
  mutations,
  actions,
  getters
}
